/** @format */

import React from 'react';

export default props => {
    return (
        <div
            style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
                zIndex: 100,
                background: 'rgba(0,0,0,.8'
            }}>
            <div
                style={{
                    position: 'absolute',
                    top: 'calc(50% - 35px)',
                    left: 'calc(50% - 100px)',
                    padding: '20px',
                    background: '#fff',
                    width: '200px',
                    height: '70px',
                    textAlign: 'center'
                }}>
                <i className="fa fa-upload mr-2" /> Drop files to upload
            </div>
        </div>
    );
};
